// Identificador OPACO da ABA, gerado uma vez por carregamento de página.
//
// Existe para o realtime do Pipeline distinguir "fui eu NESTA aba" de "fui eu
// em OUTRA aba". Antes a supressão de eco comparava `user_id`, o que descartava
// o evento em TODAS as abas do autor: criar um card na tela da conversa deixava
// o board aberto em outra aba parado até o F5 (fase-57, RT-P0-1).
//
// NÃO é credencial. Viaja num header, é ecoado de volta para os outros clientes
// e nunca participa de autorização — quem autoriza continua sendo o
// `pubsub_token` no PipelineCardChannel. Só precisa ser único entre abas.
//
// O formato precisa casar com ApplicationController::CLIENT_ID_FORMAT
// (`[A-Za-z0-9-]{8,64}`); fora dele o backend descarta o valor e ninguém
// suprime o eco.
export const CLIENT_SESSION_HEADER = 'X-Noovi-Client-Id';

let clientSessionId = null;

const randomId = () => {
  const cryptoRef = typeof window !== 'undefined' ? window.crypto : undefined;

  if (typeof cryptoRef?.randomUUID === 'function') {
    return cryptoRef.randomUUID();
  }

  if (typeof cryptoRef?.getRandomValues === 'function') {
    const bytes = cryptoRef.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join(
      ''
    );
  }

  // Contexto sem WebCrypto (http:// legado, jsdom sem polyfill). Unicidade
  // entre abas basta aqui — isto não é segredo nem credencial.
  return `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
};

export const getClientSessionId = () => {
  if (!clientSessionId) {
    clientSessionId = randomId();
  }
  return clientSessionId;
};
